import { api } from '../api'
import type { DrillWithStatistic, GameFlavor, DrillFilters } from '@acepoker/contract'

export const getDrillsWithStatistics = async ({
  isCustom,
  flavors,
  filters = {}
}: {
  isCustom?: boolean
  flavors?: GameFlavor[]
  filters?: DrillFilters
}): Promise<{
  items: DrillWithStatistic[]
  total: number
}> =>
  await api()
    .url('/api/player/drill-list-with-statistics')
    .post({
      custom: isCustom,
      flavors,
      street: filters.street,
      heroPositionGroup: filters.heroPositionGroup,
    })
    .json()

export const getDrillsPredefined = async ({
  filters = {}
}: {
  filters?: DrillFilters
}): Promise<{
  items: DrillWithStatistic[]
  total: number
}> =>
  await api().url('/api/player/predefined-drill-list').post({ filters }).json()
